import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import { CopySVG, DualArrowRightSVG, WordPressSVG } from "../../../../../components/IconSvg"
import CopyToClipboard from "react-copy-to-clipboard"
import { toast } from "react-toastify"

const FinishStep = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    return (
        <div className='mt-3' >
            <div className="finish-step-context" style={{ minHeight: '63vh' }}>
                <div className='mt-2 mb-2'>
                    <div className='general-page-title' >{t("TITLES.CONGRATULATIONS")}</div>

                    <p>{t("DESCRIPTIONS.CONGRATULATIONS1")}</p>
                    {location.state?.hasDomain && <p>
                        {t("DESCRIPTIONS.CONGRATULATIONS2")}
                    </p>}

                    {location.state?.guidScript && <> <div className="my-3">
                        <div>
                            <code>
                                {`<script>(function() {
                                    var script = document.createElement('script');
                                    script.id = '${location.state?.guidScript}';
                                    script.src = 'https://${process.env.REACT_APP_CLIENT_SUBDOMAIN}.dartamas.com/chatButtonModule.js';
                                    script.setAttribute('data-url', 'sipOnline');
                                    document.body.appendChild(script);
                                })();
                                </script>`}

                                <CopyToClipboard
                                    text={`<script>(function() {
                                    var script = document.createElement('script');
                                    script.id = '${location.state?.guidScript}';
                                    script.src = 'https://${process.env.REACT_APP_CLIENT_SUBDOMAIN}.dartamas.com/chatButtonModule.js';
                                    script.setAttribute('data-url', 'sipOnline');
                                    document.body.appendChild(script);
                                })();
                                </script>`}
                                    onCopy={() => toast.success(t('COPIED_SUCCESSFULLY'))}>
                                    <span className="cursor-pointer"><CopySVG /></span>
                                </CopyToClipboard>
                            </code>

                        </div>
                    </div>
                        <div className="plugin-context my-3">
                            <a target="_blank" href='https://wordpress.org/plugins/dartamas' >
                                <span>
                                    <WordPressSVG />
                                    {t("DOWNLOAD_PLUGIN_LINK_TEXT")}
                                </span>

                                <DualArrowRightSVG />
                            </a>
                        </div>
                    </>}

                </div>


            </div>
            <div className="d-flex justify-content-end" >
                <button className="btn btn-primary auth-form-btn"
                    onClick={() => window.location.href = "/"}
                    type="button" >  {t('ACTIONS.PORTAL_ENTERING')}</button>
            </div>
        </div>

    )
}
export default FinishStep